/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-05 11:30:02
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-14 17:53:49
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/TermsAndConditionList/index.tsx
 */
import { SizeFittingTable } from '@/src/components/Antd';
import NoPermission from '@/src/components/NoPermission';
import SalesChannelSelection from '@/src/constrains/SalesChannelSelection';
import {
  isUserValid,
  salesChannelResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import moment from 'moment';
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { MidTitle } from 'src/components/EditableTable/EditableTable';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { handleClick } from 'src/constrains/CreateButtonWithLanguageChangeWarning/tools';
import Action from 'src/pages/SalesCannelVersion/SalesChannelLegal/Components/Action';
import Add from 'src/pages/SalesCannelVersion/SalesChannelLegal/Components/AddOverlay';
import Layout from 'src/pages/SalesCannelVersion/SalesChannelLegal/Components/TableListPageLayout';
import { generateList } from 'src/pages/SalesCannelVersion/SalesChannelLegal/tools';
import { duplicateTCPages, getTCs } from 'src/request/salesChannel/legal';
//import { msg } from 'src/tools/message';
import { useI18n } from 'src/hooks/useRouterChange';
import { NEW } from 'src/tools/constant';
// import { formatDate1 } from 'src/tools/helper';
import {
  i18nGet,
  handleOnGetCurrentSCTimezoneUTC,
  handleOnFormatCurrentSCTimeAndDateWithTimezone,
} from 'src/tools/tools';
import TCSelection from './TCSelection';
import css from './css.module.less';

export const permissions = (uuid: string) => {
  const view_all_T_C_listing_page = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelLegal,
        subCategory: EnumSubCategory.ChannelLegal,
        operation: EnumOperation.view_all_T_C_listing_page,
        uuid,
      }),
    ],
  });
  const view_T_C_details_page = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelLegal,
        subCategory: EnumSubCategory.ChannelLegal,
        operation: EnumOperation.view_T_C_details_page,
        uuid,
      }),
    ],
  });
  const add_edit_T_C = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelLegal,
        subCategory: EnumSubCategory.ChannelLegal,
        operation: EnumOperation.add_edit_T_C,
        uuid,
      }),
    ],
  });
  const archive_T_C = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelLegal,
        subCategory: EnumSubCategory.ChannelLegal,
        operation: EnumOperation.archive_T_C,
        uuid,
      }),
    ],
  });
  return {
    view_all_T_C_listing_page,
    view_T_C_details_page,
    add_edit_T_C,
    archive_T_C,
  };
};

//duplicateTCPages;
const LegalPageList = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const scTimezoneUTC = handleOnGetCurrentSCTimezoneUTC();
  const [pages, setPages] = React.useState([]);
  const [basic, setBasic] = React.useState({
    salesChannelName: '',
    salesChannelUuid: null,
    timezoneInGmt: '',
  });
  const [salesChannelSelectVisible, setSalesChannelSelectVisible] =
    React.useState(false);
  const [tcSelectVisible, setTcSelectVisible] = React.useState(false);
  const [selectedSalesChannel, setSelectedSalesChannel] = React.useState([]);
  const _s = (selectedSalesChannel || [])[0];
  const [search, setSearch] = React.useState('');
  const _p: { uuid: string } = useParams();
  const _h = useHistory();
  const { uuid } = _p;
  const { view_all_T_C_listing_page, view_T_C_details_page, add_edit_T_C } =
    permissions(uuid);
  const getPages = () => {
    getTCs(uuid).then((res: any) => {
      const { salesChannelName, salesChannelUuid, timezoneInGmt, summaryList } =
        res || {};
      setPages(summaryList || []);
      setBasic({
        salesChannelName,
        salesChannelUuid,
        timezoneInGmt,
      });
    });
  };
  React.useEffect(() => {
    if (view_all_T_C_listing_page) {
      getPages();
    }
  }, []);

  // const handleOnDelete = (uuid) => {
  //   deleteTC(uuid).then((res) => {
  //     const _pages = pages.filter((i) => i.uuid !== uuid);
  //     setPages(_pages);
  //     msg.success('Terms & conditions page has been deleted');
  //   });
  // };
  const addButtonMenu = [
    {
      key: 'add',
      name: getI18n('termsAndCondition.index.addTermsConditions'),
      description: getI18n('termsAndCondition.index.addTermsConditions'),
      type: 'Add',
      onClick: () => {
        addNew(NEW);
      },
    },
    {
      key: 'duplicate',
      name: getI18n(
        'termsAndCondition.index.duplicateFromOtherTermsConditions',
      ),
      description: getI18n(
        'termsAndCondition.index.duplicateFromOtherTermsConditionsDesc',
      ),
      type: 'Duplicate',
      onClick: () => {
        setSelectedSalesChannel([]);
        setSalesChannelSelectVisible(true);
      },
    },
  ];

  const jump = (pageUuid) => {
    _h.push(
      `/salesChannel/termsAndCondition/editor/${uuid}/${pageUuid}?index=${
        pages.length + 1
      }`,
    );
  };

  const addNew = (pageUuid) => {
    handleClick({
      onClick: () => {
        _h.push(
          `/salesChannel/termsAndCondition/editor/${uuid}/${pageUuid}?index=${
            pages.length + 1
          }`,
        );
      },
      title: getI18n('termsAndCondition.index.createTermsConditions'),
      content: getI18n('termsAndCondition.index.createTermsConditionscontent'),
      onOkText: getI18n('general.antd.Uploader.ok'),
      onCancelText: getI18n('general.cancel'),
      salesChannelUuid: uuid,
    });
  };

  const handleOnEdit = (uuid) => {
    jump(uuid);
  };

  const columns = [
    {
      title: getI18n('termsAndCondition.index.termsConditionsName'),
      dataIndex: 'name',
      default: true,
      minWidth: 250,
      sorter: (a, b) => a.name.localeCompare(b.name),
      childGenerate: (text, record) => {
        const { name, contentAbbreviation } = record;
        return (
          <div className={css.container}>
            <NoWrapContainer>
              <GlobalTooltip title={name || '-'}>{name || '-'}</GlobalTooltip>
              <GlobalTooltip title={contentAbbreviation || '-'}>
                <div className={css.tips}>{contentAbbreviation || '-'}</div>
              </GlobalTooltip>
            </NoWrapContainer>
          </div>
        );
      },
    },
    {
      title: getI18n('termsAndCondition.index.versionRemarks'),
      childGenerate: (text, record) => {
        const { remarks } = record;
        return (
          <NoWrapContainer>
            <GlobalTooltip title={remarks || '-'}>
              {remarks || '-'}
            </GlobalTooltip>
          </NoWrapContainer>
        );
      },
      default: true,
      minWidth: 190,
      sorter: (a, b) => a.remarks.localeCompare(b.remarks),
    },
    {
      title: `${getI18n('general.created')} (UTC ${scTimezoneUTC})`,
      default: true,
      minWidth: 130,
      sorter: (a, b) => {
        return moment(a.createdDate || null).isBefore(
          moment(b.createdDate || null),
        )
          ? -1
          : 1;
      },
      childGenerate: (text, record) => {
        const { createdDate } = record;
        return handleOnFormatCurrentSCTimeAndDateWithTimezone(createdDate);
      },
    },
    {
      title: `${getI18n('general.lastModified')} (UTC ${scTimezoneUTC})`,
      default: true,
      minWidth: 130,
      childGenerate: (text, record) => {
        const { modifiedDate } = record;
        return handleOnFormatCurrentSCTimeAndDateWithTimezone(modifiedDate);
      },
      sorter: (a, b) => {
        return moment(a.modifiedDate || null).isBefore(
          moment(b.modifiedDate || null),
        )
          ? -1
          : 1;
      },
    },
    !view_T_C_details_page
      ? {}
      : {
          titleGenerate: () => {
            return (
              <MidTitle>
                <span>
                  {getI18n(
                    'general.advancedFilters.commonStoreProductsWithTable.actions',
                  )}
                </span>
              </MidTitle>
            );
          },
          minWidth: 140,
          default: true,
          childGenerate: (text, record) => {
            const { uuid } = record;
            return (
              <Action
                // onDelete={handleOnDelete.bind(this, uuid)}
                onEdit={handleOnEdit.bind(this, uuid)}
              />
            );
          },
        },
  ];

  const data = generateList({ data: pages, search });

  const breadcrumbData = [
    {
      url: '/',
      name: getI18n('general.sider.home'),
    },
    {
      url: '/salesChannel',
      name: basic.salesChannelName,
    },
    {
      url: '',
      name: getI18n('termsAndCondition.index.termsConditions'),
    },
  ];

  const handleOnSalesChannelCancel = () => {
    setSelectedSalesChannel([]);
    setSalesChannelSelectVisible(false);
  };

  const handleOnSalesChannelConfirm = (uuids: string[]) => {
    setSelectedSalesChannel(uuids);
    setSalesChannelSelectVisible(false);
    setTcSelectVisible(true);
  };

  const handleOnLegalSelectionCancel = () => {
    setSelectedSalesChannel([]);
    setTcSelectVisible(false);
    // setSalesChannelSelectVisible(true);
  };

  const handleOnLegalSelectionBack = () => {
    setTcSelectVisible(false);
    setSalesChannelSelectVisible(true);
  };

  const handleOnLegalSelectionConfirm = (salesChannelUuid, legalPagesUuid) => {
    duplicateTCPages(uuid, legalPagesUuid).then((res) => {
      getPages();
      handleOnLegalSelectionCancel();
    });
  };

  return view_all_T_C_listing_page ? (
    <Layout
      disableAdd={!add_edit_T_C}
      addButtonOverlay={
        <Add
          addButtonMenu={addButtonMenu}
          title={getI18n('termsAndCondition.index.createTermsConditions')}
        />
      }
      breadcrumbData={breadcrumbData}
      onSearch={setSearch}
      title={getI18n('termsAndCondition.index.allTermsConditions')}
      addText={getI18n('termsAndCondition.index.createTermsConditions')}
      addFun={addNew.bind(this, NEW)}>
      {salesChannelSelectVisible && (
        <SalesChannelSelection
          selectedItems={selectedSalesChannel || []}
          onOk={handleOnSalesChannelConfirm}
          onCancel={handleOnSalesChannelCancel}
          visible={salesChannelSelectVisible}
        />
      )}
      {tcSelectVisible && _s && (
        <TCSelection
          visible={tcSelectVisible && _s}
          onCancel={handleOnLegalSelectionCancel}
          onOk={handleOnLegalSelectionConfirm}
          salesChannelUuid={_s}
          onBack={handleOnLegalSelectionBack}
        />
      )}
      <SizeFittingTable
        id='salesChannelTermsAndConditionsList'
        rowKey={'uuid'}
        //className={styles.table}
        dataSource={data}
        pagination={false}
        columns={columns}
        className={css.table}
      />
    </Layout>
  ) : (
    <NoPermission />
  );
};
export default LegalPageList;
